export default __webpack_public_path__ + "static/us-map-southwest-a2698b014d7aa4b2020eafa12eb96833.svg";